export const formatPhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber) {
        return "";
    }
    const newPhoneNumber = phoneNumber.replace(/[^\d]/g, "");
    const newPhoneNumberLength = newPhoneNumber.length;

    if (newPhoneNumberLength < 4) {
        return newPhoneNumber;
    }
    if (newPhoneNumberLength < 7) {
        return `${newPhoneNumber.slice(0, 3)}-${newPhoneNumber.slice(3)}`;
    }
    return `${newPhoneNumber.slice(0, 3)}-${newPhoneNumber.slice(3, 6)}-${newPhoneNumber.slice(6, 10)}`;
};
